import { render, staticRenderFns } from "./EditCouponRuleCpps.vue?vue&type=template&id=a216315e&scoped=true"
import script from "./EditCouponRuleCpps.vue?vue&type=script&lang=js"
export * from "./EditCouponRuleCpps.vue?vue&type=script&lang=js"
import style0 from "./EditCouponRuleCpps.vue?vue&type=style&index=0&id=a216315e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a216315e",
  null
  
)

export default component.exports